export default "__VITE_ASSET__DqEAOKcB__"